export class ExpectedError extends Error {}
